import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {
    title = 'frontend-ts';
    useEmptyLayout = true;

    constructor(private readonly router: Router) {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
            const url = event.urlAfterRedirects.split('?')[0];
            const firstSegment = url.split('/')[1];

            this.useEmptyLayout = firstSegment === 'welcome' || firstSegment === 'print' || firstSegment === 'plannedTvgTime';
        });
    }
}
